<template>
  <app-modal :modal-id="modalId" :preloader="preloader"
             @close-modal="closeModal" modal-size="default" modal-alignment="center">
        <template slot="header">
            <h5 class="modal-title" id="exampleModalLabel">
                Lot {{ escorterData.lot_number }} - Horse {{ escorterData.horse }}
            </h5>
            <button type="button" class="close outline-none" @click.prevent="closeModal">
                <span class="mb-1">
                    <app-icon :name="'x'"></app-icon>
                </span>
            </button>
        </template>
        <template slot="body">
            <div class="row">
                <div class="col-md-12">
                    <div class="row">
                        <div class="col-5">
                            <img v-if="escorterData.escorter.path" class="img-fluid" style="border-radius: 10px;"
                                :src="escorterData.escorter.path" alt="Escorter Photo" />
                            <div v-else src="#" alt="" style="width:100%; height: 100%; background-color: #f1f5fa;"></div>                            
                        </div>
                        <div class="col-7">
                                <span class="mb-1">Nom de l'escorteur</span>
                                <h5>{{
                                    `${escorterData.escorter.first_name} 
                                    ${escorterData.escorter.middle_name} 
                                    ${escorterData.escorter.last_name}`
                                }}
                                </h5>
                                <i>{{
                                    `${$t(escorterData.escorter.category)} 
                                    ${escorterData.escorter.city} - 
                                    ${escorterData.escorter.matricule}`
                                }}
                                </i>
                                <br>
                                <hr>
                                <span class="mb-1">Numéro de l'escorteur</span>
                                <h5>
                                    <a :href="`tel:${escorterData.escorter.phone}`" class="">
                                        <app-icon :name="'phone'"/>&nbsp;
                                        {{ `${escorterData.escorter.phone}` }}
                                    </a>
                                </h5>
                        </div>
                    </div>
                </div>
            </div>
            <hr>
            <div class="row">
                <div class="col-md-7">
                    <div class="row" v-if="escorterData.driver_name">
                        <div class="col-3">
                            <app-avatar :title="escorterData.driver_name"
                                    avatar-class="avatars-w-50"
                                    img=""/>
                            
                        </div>
                        <div class="col-9">
                                <span class="mb-1">Nom du chauffeur</span>
                                <h5>
                                    {{ escorterData.driver_name }}
                                </h5>
                        </div>
                    </div>
                </div>
                <div class="col-md-5">
                    <div v-if="escorterData.driver_number">
                        <span class="mb-1">Numéro du chauffeur</span>
                        <h5>
                            <a :href="`tel:${escorterData.driver_number}`" class="">
                                <app-icon :name="'phone'"/>&nbsp;
                                {{ `${escorterData.driver_number}` }}
                            </a>
                        </h5>
                    </div>
                </div>
            </div>
        </template>
  </app-modal>
</template>

<script>
import AppFunction from '../../../../core/helpers/app/AppFunction';
import { FormMixin } from '../../../../core/mixins/form/FormMixin';
import { ModalMixin } from '../../../Mixins/ModalMixin';

export default {
    name: 'EscorterModal',
    mixins: [FormMixin, ModalMixin],
    props: {
        escorterData: {
            type: Object
        }
    },
    data() {
        return {
            preloader: false,
            modalId: 'escorter-modal',
            isModalActive: false,
        }
    },
    methods: {
        photoUrl() {
            const photoPath = this.escorterData.escorter.photo;
            return AppFunction.getAppUrl(photoPath);
        }
    },
}
</script>

<style>

</style>